/* eslint-disable import/prefer-default-export */
import config from '@/const/config';
import { easyPost } from './utils';


//  查询认证状态
export const getStudentAuthStatus = easyPost('student.auth.query', { api: config.BIKE_API, cache: true });

export const hasStudentTag = easyPost('student.tag.hit', { api: config.BIKE_API });

export const getStudentTagInfo = easyPost('student.auth.portraits', { api: config.BIKE_API });

export const recordStudentStatus = easyPost('student.auth.auto.record', { api: config.BIKE_API });
